/// <reference types="node" />

import React, { useEffect, useState, useRef } from "react";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { DarkMode, LightMode } from "@mui/icons-material";
import classes from "./Navbar.module.scss";
import logo from "../../assets/images/logo.png"; // The official logo. Has the "Muslims Achieving Excellence" text.
import logoNavbar from "../../assets/images/logo-navbar.png"; // The logo used in the navbar. Doesn't have the "Muslims Achieving Excellence" text. Made in MS Paint 😅
import useResponsive from "../../hooks/useResponsive";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { logout } from "../../store/slices/authSlice";
import { selectProfilePhoto, selectProfile } from "../../store/slices/profileSlice";
import { setSearchQuery, selectNewsfeed } from "../../store/slices/newsfeedSlice";
import { useTheme } from "../../context/ThemeContext";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import { fetchNotifications } from "../../store/slices/notificationsSlice";

import AspireLogo from "./navbar-elements/AspireLogo/AspireLogo";
import Button from "../../components/ui/button/Button";

const LandingNavbar = () => {
    const { isTabletUp } = useResponsive(); // True means desktop, false means mobile
    const dispatch = useAppDispatch();
    const user = useAppSelector((state) => state.auth.user);
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
    const profile = useAppSelector(selectProfile);
    const { unreadMessageCount, unreadOtherCount } = useAppSelector((state) => state.notifications);
    const [value, setValue] = useState(0); // Used to determine which tab is selected, 0 = newsfeed, 1 = people, 2 = notifications, 3 = profile
    const navigate = useNavigate();
    const location = useLocation();
    const { isDarkMode, toggleDarkMode } = useTheme();
    const muiTheme = useMuiTheme();

    const profilePhoto = useAppSelector(selectProfilePhoto);

    const [searchValue, setSearchValue] = useState("");

    const profileAvatarButtonRef = useRef<HTMLButtonElement>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const pollingIntervalRef = useRef<number | null>(null);

    useEffect(() => {
        if (isAuthenticated && user?.id) {
            dispatch(fetchNotifications(user.id));

            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
            }

            pollingIntervalRef.current = window.setInterval(() => {
                // // console.log("Polling for notifications...");
                dispatch(fetchNotifications(user.id!));
            }, 5000);
        } else {
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
                pollingIntervalRef.current = null;
            }
        }

        return () => {
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
            }
        };
    }, [dispatch, isAuthenticated, user?.id]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleLogout = () => {
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("authToken");
        dispatch(logout());
        setAnchorEl(null);
        navigate("/");
    };

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleProfileMenuClose = () => {
        setAnchorEl(null);
    };

    const navigateToAuth = () => {
        // handleProfileMenuClose();
        navigate("/auth");
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const query = event.target.value;
        setSearchValue(query);
        dispatch(setSearchQuery(query));
    };

    const clearSearchHandler = () => {
        setSearchValue("");
        dispatch(setSearchQuery(""));
    };

    useEffect(() => {
        if (!location.pathname.includes("/newsfeed") && searchValue) {
            setSearchValue("");
            dispatch(setSearchQuery(""));
        }
    }, [location.pathname, dispatch, searchValue]);

    useEffect(() => {
        document.body.classList.add(classes.bodyWithNavbar);
        return () => {
            document.body.classList.remove(classes.bodyWithNavbar);
        };
    }, []);

    useEffect(() => {
        if (location.pathname.includes("/newsfeed")) {
            setValue(0);
        } else if (location.pathname.includes("/people")) {
            setValue(1);
        } else if (location.pathname.includes("/notifications")) {
            setValue(2);
        } else if (location.pathname.includes("/profile")) {
            setValue(3);
        } else if (location.pathname.includes("/messaging")) {
            setValue(4);
        } else if (location.pathname.includes("/settings")) {
            setValue(5);
        }
    }, [location.pathname]);

    return (
        <div
            className={
                classes.landingNavbarContainer + " " + !isTabletUp
                    ? classes.mobileNavContainer
                    : classes.navContainer
            }
        >
            <AppBar className={classes.navbar} color="transparent" elevation={0}>
                <Toolbar className={classes.toolbar}>
                    <div className={classes.toolbarInner}>
                        <AspireLogo isAuthenticated={isAuthenticated} logo={logoNavbar} />

                        <div className="landing-navbar-buttons">
                            <IconButton onClick={toggleDarkMode} color="inherit">
                                {isDarkMode ? <LightMode /> : <DarkMode />}
                            </IconButton>
                            {/* <a href="/auth" className="btn btn-secondary">
                                Sign In
                            </a>
                            <a href="/auth" className="btn btn-primary">
                                Sign Up
                            </a> */}
                            <Button
                                variant="primary"
                                fill="outline"
                                size="small"
                                label="Sign In"
                                onClick={navigateToAuth}
                            />
                            <Button
                                variant="primary"
                                fill="solid"
                                size="small"
                                label="Sign Up"
                                onClick={navigateToAuth}
                            />
                        </div>
                        {/* {isTabletUp && (
                        )} */}
                    </div>
                </Toolbar>
            </AppBar>
        </div>
    );
};

export default LandingNavbar;
